import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { OcrAccountsAggregateRequestModel, OcrAccountsAggregateResponseModel } from "@/features/accounts/ocr/services/ocraccounts-aggregate-model";

export class OcrAccountsAggregateApi {
  /**
   * OCR明細取込API
   */
  public OcrAccountsAggregate = async (
    param: OcrAccountsAggregateRequestModel
  ): Promise<OcrAccountsAggregateResponseModel> => {
    const path = `/api/ocraccounts/aggregate`;

    const res = await ApiClient.instance.post<OcrAccountsAggregateResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
